import isRequired from './isRequired';
import getValidator from './getValidator';

const isRequiredIfAnyField = (config) => (value) => {
  const validator = getValidator(config.validator);
  const { fields, fieldValues } = config;
  if (fields.some((key) => validator({ ...config, value: config.validatorValue })(fieldValues[key]) === null)) {
    return isRequired(config)(value);
  }
  return null;
};

export default isRequiredIfAnyField;
